import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";

const fetchLogStats = async (userEmail, setTotalEncounters, setTotalExposures, setTotalHours) => {
  try {
    const logsRef = collection(db, "users", userEmail, "logs");
    const snapshot = await getDocs(logsRef);

    const encounterCount = snapshot.docs.filter(doc => {
      const log = doc.data();
      return log.involvement === "Patient Encounter - Exercised independent judgment";
    }).length;

    let exposureCount = 0;
    let totalMinutes = 0;

    snapshot.forEach((doc) => {
      const log = doc.data();
      if (log.involvement === "Patient Exposure - Screening, Testing, Shadowing") {
        exposureCount += 1;
      }
      if (log.duration) {
        totalMinutes += Number(log.duration);
      }
    });

    setTotalEncounters(encounterCount);
    setTotalExposures(exposureCount);
    setTotalHours((totalMinutes / 60).toFixed(1));
  } catch (error) {
    console.error("🔥 Firestore log fetch failed:", error.message, error);
  }
};

export { fetchLogStats };
